<template>
  <div>
    <app-header><app-nav></app-nav></app-header>
    <section class="container">
      <div class="page-header">
        <h2>Participantes Inscritos</h2>
      </div>

      <!-- <tabela-pendentes :titulo='"Inscrições Pendentes"' :lista="listaPendentes"></tabela-pendentes> -->

      <tabela-validados :titulo='"Participantes - Trail"' :lista="listaTrail"></tabela-validados>

      <!-- <tabela-caminhantes :titulo='"Participantes - Caminhada"' :lista="listaCaminhada"></tabela-caminhantes> -->

    </section>
  </div>
</template>

<script>
import AppHeader from '@/pages/layout/Header.vue'
import AppNav from './Nav.vue'
// import TabelaPendentes from '@/components/TabelaPendentes.vue'
import TabelaCaminhantes from '@/components/TabelaCaminhantes.vue'
import TabelaValidados from '@/components/TabelaValidados.vue'
import axios from 'axios'

export default {
  name: 'ListaInscritos',
  components: {
    AppHeader,
    AppNav,
    TabelaValidados,
    TabelaCaminhantes
  },
  data () {
    return {
      listaValidados: [],
    }
  },
  computed: {
    listaTrail () {
      return this.listaValidados.filter(a => {
        return a.prova == 1;
      })
    },
    listaCaminhada () {
      return this.listaValidados.filter(a => {
        return a.prova == 0;
      })
    },
    },
  mounted () {
    axios.get(process.env.WEB_API + 'getListaInscritosValidados.php')
      .then(response => this.listaValidados = response.data)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// ListaInscritos.vue?d6f63e94